import type { Router } from 'vue-router';

// 根据目标路由配置设置页面 title
export function createPageTitleRouterGuard(router: Router) {
  router.beforeEach(async (to, from) => {
    if (to.meta?.title) {
      document.title = to.meta.title as string;
    }
  });
}
